<label class="mui-checkbox">
  <input
    #checkbox
    type="checkbox"
    [id]="inputId"
    [tabindex]="tabindex"
    (change)="onChange($event)"
    [checked]="checked"
    [indeterminate]="indeterminate"
    [attr.name]="name ? name : null"
    [attr.disabled]="disabled ? true : null"
    [required]="required ? true : null"/>
  <span class="mui-checkbox__label">
    <ng-content></ng-content>
  </span>
</label>
